import React from "react";

const services = [
    {
        icon: "🎧",
        title: "DJ Services",
        desc: "Professional DJ setup with Bollywood, EDM and party music."
    },
    {
        icon: "🎤",
        title: "Live Music",
        desc: "Live singers, bands and instrumental performances."
    },
    {
        icon: "💃",
        title: "Dance Performances",
        desc: "Bollywood, Garba and traditional dance shows."
    },
    {
        icon: "🎭",
        title: "Artist Management",
        desc: "Celebrity artists and special guest performances."
    },
    {
        icon: "🎙️",
        title: "Anchor & Emcee",
        desc: "Professional event hosting and crowd engagement."
    },
    {
        icon: "✨",
        title: "Special Effects",
        desc: "LED screens, lighting effects and stage experience."
    }
];

const events = [
    {
        title: "Wedding Entertainment",
        image: "/assets/img/banner/wedding.jpg"
    },
    {
        title: "Corporate Events",
        image: "/assets/img/banner/corporate.jpeg"
    },
    {
        title: "Private Parties",
        image: "/assets/img/banner/private.jpg"
    }
];

const features = [

    "Professional Artists",

    "Premium Sound & Lighting",

    "Customized Entertainment",

    "Experienced Event Team",

    "Perfect Event Coordination",

    "Memorable Experiences"

];

const Entertainment = () => {
    return (
        <>
            {/* Breadcrumb Section Start */}
            <div className="breadcumb-section">
                <div className="breadcumb-wrapper">
                    <div className="container">
                        <div className="row">
                            <div className="col-12">
                                <div className="breadcumb-content">
                                    <h1 className="breadcumb-title">Entertainment</h1>

                                    <ul className="breadcumb-menu">
                                        <li>
                                            <a href="/">Home</a>
                                        </li>
                                        <li className="text-white">/</li>
                                        <li className="active">Entertainment </li>
                                    </ul>

                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>


            <div className="entertainment-page">
                {/* About */}

                <section className="ent-about">


                    <div className="ent-about-image">

                        <img
                            src="/assets/img/banner/entertainment.jpg"
                            alt="Entertainment"
                        />

                    </div>

                    <div className="ent-about-text">

                        <h2>
                            Complete Entertainment Solutions
                            For Every Celebration
                        </h2>

                        <p>
                            From energetic DJ nights to live performances,
                            we provide complete entertainment solutions
                            that make your celebrations more exciting.
                        </p>

                        <p>
                            Our professional artists and event team ensure
                            a perfect experience for every occasion.
                        </p>


                    </div>

                </section>

                {/* Services */}

                <section className="ent-services">

                    <h2>
                        Our Entertainment Services
                    </h2>

                    <div className="ent-service-grid">
                        {
                            services.map((item, index) => (
                                <div className="ent-card" key={index}>
                                    <div className="ent-icon">
                                        {item.icon}
                                    </div>

                                    <h3 className="title">
                                        {item.title}
                                    </h3>

                                    <p>
                                        {item.desc}
                                    </p>
                                </div>
                            ))
                        }
                    </div>
                </section>
                {/* Event Types */}
                <section className="event-section">

                    <h2>
                        Entertainment For Every Occasion
                    </h2>

                    <div className="event-grid">

                        {
                            events.map((item, index) => (

                                <div className="event-card" key={index}>

                                    <img
                                        src={item.image}
                                        alt={item.title}
                                    />

                                    <div className="event-overlay">

                                        <h3 className="title">
                                            {item.title}
                                        </h3>

                                    </div>

                                </div>

                            ))
                        }
                    </div>
                </section>

                {/* Special */}

                <section className="special-ent">


                    <h2>
                        Special Entertainment Features
                    </h2>


                    <div className="special-list">


                        <span>🎵 DJ Night Setup</span>

                        <span>🎤 Live Singer Performance</span>

                        <span>💃 Dance Shows</span>

                        <span>💡 Stage Lighting</span>

                        <span>📺 LED Screen Setup</span>

                        <span>🎆 Special Effects</span>


                    </div>


                </section>

            </div>

        </>
    );
};

export default Entertainment;
